
import {
  NavigationContainer,
} from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import LoginScreen from "./screens/session/LoginScreen";
import HomeScreen from "./screens/HomeScreen";
import ForgottenPassword from "./screens/session/ForgottenPassword";
import ForgottenPassword2 from "./screens/session/ForgottenPassword2";
import ChangePassword from "./screens/others/ChangePassword";
import ChangePassword2 from "./screens/others/ChangePassword2";
import RegisterReferral from "./screens/session/RegisterReferral";
import RegisterScreen1 from "./screens/session/RegisterScreen1";
import RegisterScreen2 from "./screens/session/RegisterScreen2";
import RegisterScreen3 from "./screens/session/RegisterScreen3";
import IndividualInvs from "./screens/others/IndividualInvs";
import PersonalHistory from "./screens/others/PersonalHistory";
import InvAvailable from "./screens/others/InvAvailable";
import InvClosed from "./screens/others/InvClosed";
import InvFull from "./screens/others/InvFull";
import InvNext from "./screens/others/InvNext";

import * as Font from "expo-font";

import { View } from "react-native";

const Stack = createNativeStackNavigator();
import React, { useState, useEffect } from "react";

//AUTOLOGIN
import AsyncStorage from "@react-native-async-storage/async-storage";


//TEMAS
import { ThemeContext } from "./components/contexts";
import { MSInvsDark, MSInvsLight } from "./components/colorThemes";

export default function App() {

  const [theme, setTheme] = useState("light");
  const [language, setLanguage] = useState("es");

  const contextThemeLang = { theme, setTheme, language, setLanguage };

  
  const [route, setRoute] = useState("Login");

  const [fontsLoaded, setFontsLoaded] = useState(false);


  useEffect(() => {
    if (!fontsLoaded) {
      loadFonts();
    }
  });

  const loadFonts = async () => {
    await Font.loadAsync({
      "Kodchasan-Regular": require("./assets/fonts/Kodchasan/Kodchasan-Regular.ttf"),
      "Kodchasan-Bold": require("./assets/fonts/Kodchasan/Kodchasan-Bold.ttf"),

      "Roboto-Light": require("./assets/fonts/Roboto/Roboto-Light.ttf"),
      "Roboto-Regular": require("./assets/fonts/Roboto/Roboto-Regular.ttf"),
      "Roboto-Medium": require("./assets/fonts/Roboto/Roboto-Medium.ttf"),
      "Roboto-Bold": require("./assets/fonts/Roboto/Roboto-Bold.ttf"),
    });

    const asyncLang = await AsyncStorage.getItem("@asyncLang");
    if (asyncLang == null) {
      await AsyncStorage.setItem("@asyncLang", "es");
    } else {
      setLanguage(asyncLang);
    }

    const asyncColor = await AsyncStorage.getItem("@asyncColor");
    if (asyncColor == null) {
      await AsyncStorage.setItem("@asyncColor", "light");
    } else {
      setTheme(asyncColor);
    }

    const asyncID = await AsyncStorage.getItem("@asyncID");
    if (asyncID != null) {
      setRoute("Home");
    } else {
      setRoute("Login");
    }

    setFontsLoaded(true);
  };

  if (!fontsLoaded) {
    return <View />;
  }

  const config={
    screens:
      {
        Home:{
          screens:{
            Inicio: 'webapp/home',
            Explorar: 'webapp/search',
            'Añadir fondos': 'webapp/add',
            'Mis inversiones': 'webapp/invs',            
            Perfil: 'webapp/profile',            
          }
        },
        Login: 'webapp/login',
        RegisterReferral: 'webapp/registerReferral',
        RegisterScreen1: 'webapp/register1',
        RegisterScreen2: 'webapp/register2',
        RegisterScreen3: 'webapp/register3',
        ForgottenPassword: 'webapp/forgottenCheck',
        ForgottenPassword2: 'webapp/forgottenNew',
        ChangePassword: 'webapp/changePasswordCheck',
        ChangePassword2: 'webapp/changePasswordNew',
        IndividualInvs: 'webapp/investment',
        PersonalHistory: 'webapp/history',
        InvAvailable: 'webapp/available',
        InvClosed: 'webapp/closed',
        InvFull: 'webapp/full',
        InvNext: 'webapp/next',
      }
  };

  const linking={
    prefixes: ['https://msinvs.com/webapp'],
    config
  };

  return (
    <>
      {
        <ThemeContext.Provider value={contextThemeLang}>
          <NavigationContainer
          linking={linking}
            theme={theme == "light" ? MSInvsLight : MSInvsDark}
          >
            <Stack.Navigator
              initialRouteName={route}
              screenOptions={{
                headerShown: false,
              }}
              headerMode="none"
            >
              <Stack.Screen
                options={{ headerShown: false }}
                name="Login"
                component={LoginScreen}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="Home"
                component={HomeScreen}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="ForgottenPassword"
                component={ForgottenPassword}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="ForgottenPassword2"
                component={ForgottenPassword2}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="ChangePassword"
                component={ChangePassword}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="ChangePassword2"
                component={ChangePassword2}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="RegisterReferral"
                component={RegisterReferral}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="Register1"
                component={RegisterScreen1}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="Register2"
                component={RegisterScreen2}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="Register3"
                component={RegisterScreen3}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="IndividualInvs"
                component={IndividualInvs}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="PersonalHistory"
                component={PersonalHistory}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="InvAvailable"
                component={InvAvailable}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="InvClosed"
                component={InvClosed}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="InvFull"
                component={InvFull}
              />
              <Stack.Screen
                options={{ headerShown: false }}
                name="InvNext"
                component={InvNext}
              />
            </Stack.Navigator>
          </NavigationContainer>
        </ThemeContext.Provider>
      }
    </>
  );
}